import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";

import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-sb-com-accessories',
    imports: [FormsModule, MatIcon],
    templateUrl: './sb-com-accessories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './sb-com-accessories.component.css'
})
export class SbComAccessoriesComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  ballValveSelection!: GuruEntity;
  electricHeaterSelection!: GuruEntity;
  hoseKitsSelection!: GuruEntity;
  flowRateSelection!: GuruEntity;
  filterSelection!: GuruEntity;
  thermostatSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  drainPanSelection!: GuruEntity;
  waterValveSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.RATINGS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.ballValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBallValveConn');
    this.electricHeaterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USElecHtKw');
    this.hoseKitsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHoseKit');
    this.flowRateSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFlowrate');
    this.filterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFilter');
    this.thermostatSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USThermostat');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlACC');
    this.drainPanSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDrainPan');
    this.waterValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWaterValve');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
